/**
 * Saving a run's results: which of its boxes the user took out, sent as `drop` so the saved job
 * holds what the panel counts as found.
 */

// A square's review verdict that takes out its boxes (VERDICT.CLEARED in useFindResults)
const CLEARED = 'cleared';
// Boxes the user added are not the run's: the server has no such ids
const ADDED_SOURCES = ['manual', 'click'];

/**
 * The ids of the run's boxes not to save: removed by hand, in a square cleared in review (unless
 * kept by hand), or hidden by the size filter. Previews and boxes the user added are not the run's
 * and are left out.
 * @param {Object} params
 * @param {Object[]} params.results - Every result of the search (searchState), size filter or not
 * @param {Object} [params.decisions] - id → 'accepted' | 'rejected', by hand
 * @param {Object} [params.tileReview] - Plan tile index → 'ticked' | 'cleared'
 * @param {Function} [params.hidden] - Whether the size filter hides a result
 * @returns {string[]}
 */
export const dropIds = ({ results, decisions = {}, tileReview = {}, hidden = () => false }) =>
	results
		.filter(
			result =>
				!result.preview &&
				!(result.sources ?? []).some(source => ADDED_SOURCES.includes(source))
		)
		.filter(result => {
			const hand = decisions[result.id];
			if (hand === 'rejected') return true;
			if (tileReview[result.tile] === CLEARED && hand !== 'accepted') return true;
			return hidden(result);
		})
		.map(result => result.id);
